import './cmsSearchBridge';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './theme.css';
import reportWebVitals from './reportWebVitals';

async function bootstrap() {
  const userToken = new URLSearchParams(window.location.search).get('token');
  const displayMode = window.location.pathname === '/affichage' || String(userToken || '').toLowerCase() === 'tableau';

  if (userToken && userToken !== 'null') {
    try {
      const response = await fetch(
        `https://appel.amservices.eu/api/auto_login.php?token=${encodeURIComponent(userToken)}`
      );
      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Auto-connexion impossible');
      }

      localStorage.setItem('authToken', data.token);
      localStorage.setItem('userRole', data.user.role);
      localStorage.setItem('isAdmin', data.user.role === 'admin' ? 'true' : 'false');
      localStorage.setItem('user', JSON.stringify(data.user));

      window.history.replaceState({}, document.title, displayMode ? '/affichage' : '/depannage');
    } catch (error) {
      console.error('Erreur auto-login:', error);
    }
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// À mettre tout en bas de ton src/index.js (CRM)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      // Vérifie si une mise à jour existe sur le serveur
      registration.update();

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker) {
          installingWorker.onstatechange = () => {
            // Si le nouveau build est téléchargé et prêt
            if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // On force le rafraîchissement automatique
              window.location.reload();
            }
          };
        }
      };
    }
  });
}
